import { Select } from '../../../../../../../components/select/select';
import { useLang } from '../../../../../../../hooks/use-lang';
import { useInputLangStore } from '../../../../../../../store/use-input-lang-store';
import { FormElementType } from '../../../../../../../store/api/forms-api';
import { useFormStore } from '../../../../../../../store/use-form-store';

interface Props {
  formElement?: Partial<FormElementType>;
}

export const FormCreateSelect = ({ formElement }: Props) => {
  const { getLocale } = useLang();
  const { language } = useInputLangStore();
  const { newElement } = useFormStore();

  const options = formElement ? formElement?.info?.options : newElement?.info?.options;
  const placeholder = formElement ? formElement.info?.helper_text : newElement?.info?.helper_text;
  const helper = formElement ? formElement.info?.helper : newElement?.info?.helper;

  return (
    <Select
      options={
        options?.map((item, index) => ({
          id: index.toString(),
          value: getLocale(item, language),
        })) || []
      }
      placeholder={helper === 'placeholder' ? getLocale(placeholder, language) : undefined}
    />
  );
};
